import { render, staticRenderFns } from "./PokemonBattleInfo.vue?vue&type=template&id=e0aca788&scoped=true&"
import script from "./PokemonBattleInfo.vue?vue&type=script&lang=js&"
export * from "./PokemonBattleInfo.vue?vue&type=script&lang=js&"
import style0 from "./PokemonBattleInfo.vue?vue&type=style&index=0&id=e0aca788&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0aca788",
  null
  
)

export default component.exports